"use client";

import { LogoIcon } from "../Icons";

export default function FooterScrollButton() {
  return (
    <button
      className="block w-[173px]  h-[42px]"
      onClick={e => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
      }}
      aria-label="Scroll to top"
    >
      <LogoIcon color="#0B1B33" />
    </button>
  );
}
